/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type DefaultCleansingRulesEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>, // oxlint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const defaultCleansingRulesEntryPoint: EntryPoint<
	DefaultCleansingRulesEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<DefaultCleansingRulesEntryPointComponent>(
		/* webpackChunkName: "async-default-cleansing-rules" */ './DefaultCleansingRulesPage.tsx',
	),
	getPreloadProps: () => ({
		extraProps: {},
	}),
});
